<template>
  <div class="bg-gray-800 text-white px-4 py-3 flex items-center justify-between move-handler cursor-move">
    <div class="text-sm font-semibold">
      {{ index + 1 }}. 

      <select 
      	:value="liabilityType"
      	class="ml-2 text-black outline-none" 
      	v-on:change="updateValue({
					index   : index,
					key     : 'type',
					value   : $event.target.value,
					objectId: liabilityId
      	})">
      	<option value="0">Property Loan</option>
      	<option value="1">Credit Card</option>
      	<option value="2">Car Lease</option>
      	<option value="3">Personal Loan</option>
        <option value="5">HECS/HELP Debt</option>
        <option value="6">Buy-Now-Pay-Later</option>
      	<option value="4">Other</option>
      </select>
    </div>

    <div class="">
      <a href="#" @click.prevent class="text-white no-underline text-sm hover:no-underline"
        v-tooltip.top="{ content: 'You can click and drag to change the ordering' }">Move</a>
      <a href="#" @click.prevent="deleteLiability(liabilityId, index)" class="text-white no-underline text-sm hover:underline ml-4">Delete</a>
    </div>
  </div>
</template>

<script>
	export default {
		props : {
			index : {
				type    : Number,
				required: true
			},

			updateValue : {
				type    : Function,
				required: true
			},

			liabilityId : {
				type    : Number,
				required: true
			},

			liabilityType : {
				type    : Number,
				required: true
			},

			deleteLiability : {
				type    : Function,
				required: true
			}
		},

    computed : {
      liabilityTypeLabel() {
        if(this.liabilityType == 0) return 'Property Loan'
        else if(this.liabilityType == 1) return 'Credit Card'
        else if(this.liabilityType == 2) return 'Car Lease'
        else if(this.liabilityType == 3) return 'Personal Loan'
        else if(this.liabilityType == 4) return 'Other'
      }
    }
	}
</script>